export default function Header (){
	return (
		<div className="header">
			Casey Moir
		</div>
	);
}